export default __webpack_public_path__ + "static/media/profil.455df285.png";